var _rect, _rect2, _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26.3077,
    rx: 4,
    fill: "#DC1919",
    fillOpacity: 0.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 25.6,
    height: 25.9077,
    rx: 3.8,
    stroke: "#DC1919",
    strokeOpacity: 0.26,
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9376 7.09375C11.6778 7.09375 11.4451 7.25446 11.3531 7.49741L11.2096 7.87633C10.902 7.8456 10.6185 7.81492 10.3891 7.78916C10.2176 7.7699 10.0766 7.75343 9.97869 7.7418L9.86572 7.72824L9.82735 7.72355C9.4848 7.68113 9.17222 7.92438 9.1298 8.26694C9.08738 8.6095 9.33069 8.92159 9.67325 8.96401L9.715 8.96912L9.83124 8.98307C9.93145 8.99497 10.0751 9.01176 10.2496 9.03135C10.5984 9.07051 11.0717 9.12105 11.5683 9.16637C12.2381 9.22751 12.9724 9.28125 13.5001 9.28125C14.0277 9.28125 14.762 9.22751 15.4319 9.16637C15.9285 9.12105 16.4018 9.07051 16.7505 9.03135C16.925 9.01176 17.0687 8.99497 17.1689 8.98307L17.2851 8.96912L17.3268 8.96402C17.6694 8.9216 17.9127 8.6095 17.8703 8.26694C17.8279 7.92438 17.5158 7.68107 17.1733 7.72349L17.1344 7.72824L17.0214 7.7418C16.9235 7.75343 16.7825 7.7699 16.611 7.78916C16.3816 7.81492 16.0982 7.8456 15.7906 7.87633L15.6471 7.49741C15.5551 7.25446 15.3224 7.09375 15.0626 7.09375H11.9376Z",
    fill: "#DC1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8751 13.3438C12.8751 12.9986 12.5952 12.7188 12.2501 12.7188C11.9049 12.7188 11.6251 12.9986 11.6251 13.3438V16.4688C11.6251 16.8139 11.9049 17.0938 12.2501 17.0938C12.5952 17.0938 12.8751 16.8139 12.8751 16.4688V13.3438Z",
    fill: "#DC1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7501 12.7188C15.0952 12.7188 15.3751 12.9986 15.3751 13.3438V16.4688C15.3751 16.8139 15.0952 17.0938 14.7501 17.0938C14.4049 17.0938 14.1251 16.8139 14.1251 16.4688V13.3438C14.1251 12.9986 14.4049 12.7188 14.7501 12.7188Z",
    fill: "#DC1919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8186 11.0316C17.8752 10.2386 17.1916 9.6029 16.4146 9.69269C15.6196 9.78456 14.3928 9.90625 13.5001 9.90625C12.6074 9.90625 11.3805 9.78456 10.5855 9.69269C9.80855 9.6029 9.12489 10.2386 9.18153 11.0316L9.71699 18.528C9.75758 19.0963 10.1809 19.5768 10.7617 19.6641C11.3846 19.7578 12.5275 19.9074 13.5008 19.9063C14.4621 19.9051 15.6097 19.7562 16.2353 19.6633C16.8172 19.577 17.2426 19.0963 17.2833 18.5263L17.8186 11.0316ZM16.5581 10.9344C16.5603 10.9342 16.562 10.9343 16.562 10.9343L16.5636 10.9347C16.565 10.9352 16.5672 10.9363 16.5693 10.9384C16.5708 10.9397 16.5718 10.9414 16.5718 10.9414L16.5718 10.9425L16.037 18.4291C15.4178 18.5206 14.3566 18.6553 13.4993 18.6563C12.6327 18.6573 11.5781 18.5224 10.9632 18.4303L10.4284 10.9425L10.4283 10.9414C10.4283 10.9414 10.4294 10.9397 10.4308 10.9384C10.433 10.9363 10.4351 10.9352 10.4365 10.9347L10.4382 10.9343C10.4382 10.9343 10.4398 10.9342 10.442 10.9344C11.2384 11.0265 12.5285 11.1563 13.5001 11.1563C14.4717 11.1563 15.7617 11.0265 16.5581 10.9344Z",
    fill: "#DC1919"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDeleteIcon);
export default __webpack_public_path__ + "static/media/caseDeleteIcon.a997ce517f9f4a8eda172cfbe15950ab.svg";
export { ForwardRef as ReactComponent };